import styled from 'styled-components';

export const StyledFormElement = styled.div`
width: 100%;
box-sizing: border-box;
padding: 15px 0;
display: flex;
`;